// Generic per-cell value formatter — extends cellFormatter.js's shape (which only ever
// ADJUSTED what DevExtreme had already rendered) into the thing that actually produces
// display content, since nothing pre-renders for us anymore. Numbers route through
// devextreme/localization's formatNumber against a DevExtreme-style `column.format` string —
// the same reliable building block already used in the live pdfExporter.js's
// measureRequiredNumericColumnWidths. Dates use this app's own toShortDateString() convention
// instead (see below).
import { formatNumber } from 'devextreme/localization';

const PERCENT_PATTERN = /%/;
const BR_TAG_TEST_PATTERN = /<br\s*\/?>/i;
const BR_TAG_REPLACE_PATTERN = /<br\s*\/?>/gi;

export function formatValue({ value, column }) {
    if (value === null || value === undefined || value === '') return '';
    if (!column) return String(value);

    if (column.cellTemplate === 'ActiveStatus') {
        return (value === 'N' || !value) ? 'Active' : 'Inactive';
    }
    if (column.cellTemplate === 'RadioTemplate') {
        return (value === 'N' || !value) ? 'No' : 'Yes';
    }

    // toShortDateString/toShortTimeString (prototype-date.js) are this app's own date display
    // convention across gcorp-web-app/cx — used here instead of toLocaleDateString()/formatDate()
    // so exported dates read the same as they do everywhere else in the app, regardless of the
    // browser's locale.
    if (column.dataType === 'datetime') {
        const d = new Date(value);
        return `${d.toShortDateString()}, ${d.toShortTimeString()}`;
    }
    if (column.dataType === 'date') {
        return new Date(value).toShortDateString();
    }

    if (column.dataType === 'number' || typeof value === 'number') {
        const isPercent = typeof column.format === 'string' && PERCENT_PATTERN.test(column.format);
        if (isPercent) return `${Number(value).toFixed(2)} %`;
        if (value === 0) return '-'; // mirrors cellCustomizerPdf.js's zero-value "-" placeholder
        return column.format ? formatNumber(value, column.format) : String(value);
    }

    if (typeof value === 'string' && BR_TAG_TEST_PATTERN.test(value)) {
        return value.replace(BR_TAG_REPLACE_PATTERN, '');
    }

    return String(value);
}
